import React, { CSSProperties, Fragment, useEffect, useState } from 'react'
import { IQuestionEditor } from 'app_components/modules/academicComponentEditor/containers/academicComponentEditorFunctions';
import QuestionOpenAnswerComponent from '../questions/questionOpenAnswer/containers/questionOpenAnswerComponent';
import QuestionMultipleChoiceUniqueAnswer from '../questions/questionMultipleChoiceUniqueAnswer/containers/questionMultipleChoiceUniqueAnswerComponent'
import QuestionMultipleChoiceMultipleAnswer from '../questions/questionMultipleChoiceMultipleAnswer/containers/questionMultipleChoiceMultipleAnswerComponent'
import QuestionselectrangeModule from '../questions/questionselectrange/index';
import LabelComponent from 'app_components/commons/LabelComponent/LabelComponent';
import parse from 'html-react-parser';
import ButtonComponent from 'app_components/commons/Button/ButtonComponent';
import { Modal } from 'react-bootstrap';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import { useSelector } from 'react-redux';
import { CombinedReducers } from 'app_events/index';

import * as InteractionTypes from 'app_events/interaction/types'
import EditorService from 'app_services/editor/editorService';
import ProgressBarComponent from 'app_components/commons/progressBar';

import moment from 'moment'

import './surveyComponent.scss'
import ModalTextInfo from 'app_components/commons/ModalTextInfo/ModalTextInfo';
import { useTranslation } from 'react-i18next';

interface IAttemptSurvey{
  score?: number
  surveyRelated?: string
  statistics: {
    _id?: string
    question: string
    answer: string | string[]
  }[]
  questionsToEvaluate: string[]
  status?: string
}

interface ISurveyComponentProps {
  data: any
  className?: string
  style?: CSSProperties
  open?: boolean
  path?: InteractionTypes.IPathInteraction
  onClose: () => void
}

const SurveyComponent: React.FC<ISurveyComponentProps> = (props) => {

  const [attempt, updateAttempt] = useState<IAttemptSurvey>({statistics: [], questionsToEvaluate: []})
  const [loading, updateLoading] = useState<boolean>(false)
  const [questions, updateQuestions] = useState<IQuestionEditor[]>([])
  const [currentQuestion, updateCurrentQuestion] = useState<IQuestionEditor | undefined>(undefined)
  const [questionsAnswered, updateQuestionsAnswered] = useState<number>(0)
  const [showAlert, setShowAlert] = useState<boolean>(false)
  const user = useSelector((store: CombinedReducers) => store.auth.user)
  const isWithoutTutorSurvey = ['withoutTutor-survey'].includes(props.path?.surveyRelatedContent?.course_modes_mixed ?? '');
  const { t } = useTranslation()

  // @INFO Servicios
  const editorService = new EditorService()

  // @INFO Obtener la data inicial de la encuesta (ejercicio)
  useEffect(() => {
    if(props.data){
      getResourceData(props.data)
    }
  },[props.data])

  // @INFO Agregar preguntas a evaluar
  useEffect(() => {
    if(questions?.length){
      // @INFO Actualizar las questionsToEvaluate del attempt
      const questionsId = questions.reduce((accum: string[], item) => {
        if(!accum.includes(item.question._id)){
          accum.push(item.question._id)
        }
        return accum
      },attempt.questionsToEvaluate)
      updateAttempt({...attempt, questionsToEvaluate: [...questionsId]})
    }
  }, [questions])

  useEffect(() => {
    if(currentQuestion){
      // @INFO Actualizar el attempt
      if(attempt?.statistics?.length){
        handleSendQuestions()
      }
    }
  },[currentQuestion])

  /**
   * @INFO Organizar la información de la encuesta
   * @param _data
   */
  const getResourceData = async (_data?: any) => {
    let data: any = undefined
    if(_data){
      data = {..._data}
    }
    if(data){
      const _questions: IQuestionEditor[] = data?.config?.questions
      if(_questions?.length){
        // @INFO Reorganizar las preguntas
        const newQuestions = _questions.reduce((accum: IQuestionEditor[], item) => {
          if(item.question.question_category.name !== 'container'){
            accum.push({...item})
          }else{
            if(item.childs?.length){
              accum = [...accum, ...item.childs]
            }
          }
          return accum
        }, [])
        updateQuestions([...newQuestions])
        // updateCurrentQuestion({...newQuestions[0]})
        // @INFO Si viene el attempt_active lo actualizo
        if(data?.config?.attempt_active){
          updateAttempt({
            statistics: data?.config?.attempt_active?.results?.statistics,
            questionsToEvaluate: data?.config?.attempt_active?.results?.questionsToEvaluate,
            score: data?.config?.attempt_active?.results?.score
          })
          const questionsAnswered = data?.config?.attempt_active?.results?.statistics
          const newCurrentQuestion = questionsAnswered?.length ? questionsAnswered.length - 1 : 0
          updateCurrentQuestion({...newQuestions[newCurrentQuestion]})
        }
      }
    }
  }

  /**
   * @INFO Actualizar la respuesta de una pregunta
   * @param answer
   * @param _question
   */
  const handleChangeQuestion = (answer: string | string[], _question: string) => {
    const aux = {...attempt}
    const idx = aux.statistics?.findIndex((item) => item.question === _question)
    if(idx >= 0){
      aux.statistics[idx].answer = answer
    }else{
      aux.statistics.push({
        question: _question,
        answer
      })
    }
    updateAttempt({...aux})
  }

  /**
   * @INFO Renderizar pregunta según el tipo
   * @param question
   * @returns
   */
  const getQuestionFromCategory = (_question: IQuestionEditor) => {
    const question = {..._question.question}
    const category = question.question_category?.name
    if(!category) return null
    let component: any | undefined = undefined
    switch(category){
      case 'open-answer':
        component = (
          <QuestionOpenAnswerComponent
            attemptInformation={attempt}
            questionData={question}
            onSendAnswer={()=>{}}
            onChange={(answer) => handleChangeQuestion(answer, question._id)}
            hideButtons
            key={question._id}
          />
        )
        break
      case 'multiple-choice-multiple-answer':
        component = (
          <QuestionMultipleChoiceMultipleAnswer
            attemptInformation={attempt}
            questionData={question}
            onSendAnswer={()=>{}}
            onChange={(answer) => handleChangeQuestion(answer, question._id)}
            hideButtons
            key={question._id}
          />
        )
        break
      case 'multiple-choice-unique-answer':
        component = (
          <QuestionMultipleChoiceUniqueAnswer
            attemptInformation={attempt}
            questionData={question}
            onSendAnswer={()=>{}}
            onChange={(answer) => handleChangeQuestion(answer, question._id)}
            hideButtons
            key={question._id}
          />
        )
        break
      case 'select-range':
        component = (
          <QuestionselectrangeModule
            attemptInformation={attempt}
            questionData={question}
            onSendAnswer={()=>{}}
            onChange={(answer) => handleChangeQuestion(answer, question._id)}
            hideButtons
            key={question._id}
          />
        )
        break
      default:
        break
    }
    // @INFO Si hay pregunta devolverla con el content
    if(component){
      return (
        <>
          <LabelComponent
            style={{marginBottom: '-10px'}}
          >
            {parse(question.content)}
          </LabelComponent>
          {component}
        </>
      )
    }else{
      return null
    }
  }

  /**
   * @INFO Obtener el content del contenedor del currentQuestion
   */
  const getContentContainer = (_idParent?: string) => {
    if(!_idParent) return null
    if(props.data?.config?.questions?.length){
      const container: IQuestionEditor = props.data.config.questions.find((item: any) => item.question._id === _idParent)
      if(container){
        return (
          parse(container.question.content)
        )
      }
    }
    return null
  }

  /**
   * @INFO Cambiar de pregunta
   * @param type
   */
  const handleNextPrevQuestion = (type: 'next' | 'prev') => {
    const totalQuestions = questions?.length
    let currentPosition = questions.findIndex((item) => item.question._id === currentQuestion?.question._id)
    if(currentPosition < 0) return
    if(type === 'next'){
      if(currentPosition < totalQuestions-1){
        if (questions[currentPosition+1]) {
          updateCurrentQuestion({...questions[currentPosition+1]})
        } else {
          handleSendQuestions()
        }
      } else {
        handleSendQuestions()
      }
    }else if(type === 'prev'){
      if(currentPosition > 0){
        updateCurrentQuestion({...questions[currentPosition-1]})
      }
    }
  }

  /**
   * @INFO Enviar la encuesta para calificar
   */
  const handleFinish = async () => {
    // @INFO Envío el intento para calificar y llamo el onClose
    updateLoading(true)
    await handleSendQuestions(true)
    updateLoading(false)
    props.onClose()
  }

  /**
   * @INFO Actualizar el attempt con la data
   */
  const handleSendQuestions = async (qualify?: boolean) => {
    updateLoading(true)
    let results = {...attempt}
    if (props.path?.surveyRelated) {
      results['surveyRelated'] = props.path?.surveyRelated
    }
    if (qualify) {
      results['status'] = 'ended';
    }

    const params = {
      results,
      academic_resource_config: props.path?.academic_resource_config,
      user: user?.data?.id,
      deliverable_date: (new Date())
    }
    const response = await editorService.sendAttemptResults(params, qualify ? true : false)
    updateQuestionsAnswered(attempt.statistics ? attempt.statistics.length : 0)
    updateLoading(false)
  }

  /**
   * @INFO Mostrar el botón de siguiente
   * @returns
   */
  const isNext = () => {
    const totalQuestions = questions?.length
    let currentPosition = questions.findIndex((item) => item?.question._id === currentQuestion?.question?._id)
    if(currentPosition < 0) return false
    if(currentPosition < totalQuestions-1){
      return true
    }
    return false
  }

  /**
   * @INFO Mostrar el botón de siguiente
   * @returns
   */
   const isEnded = () => {
    const totalQuestions = questions?.length
    if (questionsAnswered >= totalQuestions) return true
    return false
  }

  /**
   * @INFO Mostrar el botón de siguiente
   * @returns
   */
  const isPrev = () => {
    let currentPosition = questions.findIndex((item) => item?.question?._id === currentQuestion?.question?._id)
    if(currentPosition < 0) return false
    if(currentPosition > 0){
      return true
    }
    return false
  }

  /**
   * @INFO Iniciar la encuesta
   */
  const handleStart = () => {
    if(questions?.length){
      updateCurrentQuestion({...questions[0]})
    }
  }

  /**
   * @INFO Actualizar el progreso de la encuesta
   */
  const getProgress = () => {
    const totalQuestions = questions?.length
    const currentQuestions = attempt?.statistics?.length
    if(totalQuestions && currentQuestions !== undefined){
      return `${Math.round((questionsAnswered)*100/totalQuestions)}%`
    }else{
      return '0%'
    }
  }

  const handleClose = () => {
    setShowAlert(true)
  }

  const getQuestionsAnswered = () => {
    if (questionsAnswered > questions.length) {
      return `${questions.length}/${questions.length} Respondidas`
    } else {
      return `${questionsAnswered}/${questions.length} Respondidas`
    }
  }

  return(
    <Fragment>
      <ModalTextInfo
        title={t("screens.survey.alert.title")}
        description={t("screens.survey.alert.description")}
        buttonText={t("screens.survey.alert.buttonText")}
        open={showAlert}
        onClose={props.onClose}
      />
      <Modal
        show={props.open && !showAlert}
        onHide={handleClose}
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName='dialog-survey-component'
      >
        <Modal.Body>
          <div
            className={`survey_component-layout ${props.className ? props.className : ''}`}
            style={props.style}
          >
            <div className="header-survey-modal">
              <p>{props.data?.title}</p>
              <AiOutlineCloseCircle
                onClick={handleClose}
              />
            </div>
            <div className="body-survey-modal">
              <div className="survey-metadata">
                {props.path?.surveyRelatedContent?.endDate && (
                  <p>{moment(props.path?.surveyRelatedContent?.endDate).format('DD/MM/YYYY')}</p>
                )}
                {props.path?.surveyRelatedContent?.name && (
                  <p><b>Curso: </b>{props.path?.surveyRelatedContent?.name}</p>
                )}
                {!isWithoutTutorSurvey && props.path?.surveyRelatedContent?.teacher && (
                  <p>
                    <b>Docente: </b>
                    {`${props.path?.surveyRelatedContent?.teacher?.profile?.first_name} ${props.path?.surveyRelatedContent?.teacher?.profile?.last_name}`}
                  </p>
                )}
              </div>
              {currentQuestion ?
                <div className="container-question-survey">
                  <div>
                    {getContentContainer(currentQuestion?.question?.parent)}
                  </div>
                  <div>
                    {currentQuestion ?
                      getQuestionFromCategory(currentQuestion)
                    :null}
                    <div
                      style={{marginTop: '15px'}}
                    >
                      <ProgressBarComponent
                        progress={getProgress()}
                        background='#00BB7E'
                        height='15px'
                      />
                      <p
                        style={{ fontWeight: 'bold', margin: '0px' }}
                      >
                        {getQuestionsAnswered()}
                      </p>
                    </div>
                  </div>
                </div>
              :
                <div>
                  {props.data?.description}
                </div>
              }
            </div>
            <div
              className="container-buttons"
              style={{ display: 'flex', gap: '10px' }}
            >
              {questions?.length ?
                <>
                  {!currentQuestion ?
                    <ButtonComponent
                      variant='secondary'
                      onClick={handleStart}
                      loading={loading}
                    >
                      Empezar
                    </ButtonComponent>
                  :null}
                  {isPrev() && currentQuestion ?
                    <ButtonComponent
                      variant='accent'
                      onClick={() => handleNextPrevQuestion('prev')}
                    >
                      Anterior
                    </ButtonComponent>
                  : null}
                  {currentQuestion &&
                    <>
                      {isNext() &&
                        <ButtonComponent
                          variant='secondary'
                          onClick={() => handleNextPrevQuestion('next')}
                        >
                          Siguiente
                        </ButtonComponent>
                      }
                      {isEnded() &&
                        <ButtonComponent
                          variant='secondary'
                          onClick={handleFinish}
                          loading={loading}
                        >
                          Enviar
                        </ButtonComponent>
                      }
                    </>
                  }
                </>
              : null}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
}

export default SurveyComponent;
